import {
  arrayBufferDownload,
  arrayBufferDownloadExcel,
  downloadCSV,
} from "../../../../utils/download";
import {
  decorateEmptyGridValues,
  setColumnDefaultExtraProps,
} from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_VEHICLE_STEREOTYPE_LIST,
  TOAST,
  FETCH_VEHICLE_STEREOTYPE_INIT,
  FETCH_VEHICLE_STEREOTYPE_DETAIL,
  EXPORT_VEHICLE_STEREOTYPE,
  CREATE_VEHICLE_STEREOTYPE,
  EDIT_VEHICLE_STEREOTYPE,
  INIT_CREATE_VEHICLE_STEREOTYPE_SCREEN,
  VEHICLE_MODELDD,
  VEHICLE_STEREOTYPE_DD,
  DELETE_VEHICLE_STEREOTYPE,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  VEHICLE_STEREOTYPE_SAVE_TABLE_STATE,
} from "../../../types/vehiclestereotype.type";

const formFieldValueMap = {
  id: null,
  description: "",
  modBy: "",
  modTime: "",
  status: 1,
  title: "",
  userId: "",
};

const INITIAL_STATE = {
  vehicleStereoTypeListview: [],
  vehicleModelDD: [],
  vehicleStereoTypeDD: [],
  isVehicleModelDDSuccess: false,
  isVehicleModelDDError: false,
  isVehicleStereoTypeDDSuccess: false,
  isVehicleStereoTypeDDError: false,
  isLoading: false,
  error: null,
  formFieldValueMap,
  isVehicleStereoTypeCreateSuccess: false,
  isVehicleStereoTypeCreateError: false,
  isVehicleStereoTypeDetailSuccess: false,
  isVehicleStereoTypeDetailError: false,
  isVehicleStereoTypeEditSuccess: false,
  isVehicleStereoTypeEditError: false,
  isVehicleStereoTypeExportSuccess: false,
  isVehicleStereoTypeExportError: false,
  isUploadImageSuccess: false,
  isUploadImageError: false,
  imageUploadResponse: null,
  savedTableState: null,
};

const tranformToGridView = (data) => {
  const rows = data.map((item) => {
    const { crtBy, crtTime, description, id, modBy, modTime, status, title } =
      item;

    const transformedValues = {
      crtBy,
      crtTime,
      description,
      id,
      modBy,
      modTime,
      status,
      title,
    };
    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Ac Type",
      dataKey: "title",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Description",
      dataKey: "description",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Crt By",
      dataKey: "crtBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Crt Time",
      dataKey: "crtTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Mod By",
      dataKey: "modBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Edit Time",
      dataKey: "modTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
  ];

  return {
    datas: { columns, rows },
  };
};

export const vehicleStereoTypeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_VEHICLE_STEREOTYPE_INIT:
      return { ...INITIAL_STATE, isLoadingPage: true, savedTableState: state.savedTableState };
    case FETCH_VEHICLE_STEREOTYPE_DETAIL.START:
      return { ...state, isLoading: true, isVehicleStereoTypeDetailSuccess: false };
    case EXPORT_VEHICLE_STEREOTYPE.START:
    case UPLOAD_IMAGE.START:
    case FETCH_VEHICLE_STEREOTYPE_LIST.START:
    case CREATE_VEHICLE_STEREOTYPE.START:
    case EDIT_VEHICLE_STEREOTYPE.START:
    case VEHICLE_MODELDD.START:
    case VEHICLE_STEREOTYPE_DD.START:
    case DELETE_VEHICLE_STEREOTYPE.START:
      return { ...state, isLoading: true };

    case FETCH_VEHICLE_STEREOTYPE_LIST.SUCCESS: {
      const { page, data } = action.payload;

      let resetState = {
        vehicleStereoTypeListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isVehicleStereoTypeCreateSuccess: false,
        isVehicleStereoTypeCreateError: false,
        savedTableState: state.savedTableState,
      };
      if (!data) {
        return resetState;
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = tranformToGridView(data);
      return {
        ...resetState,
        vehicleStereoTypeListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }
    case FETCH_VEHICLE_STEREOTYPE_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        vehicleStereoTypeListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        isvehicleStereoTypeDeletionSuccess: false,
        isvehicleStereoTypeDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_VEHICLE_STEREOTYPE_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isVehicleStereoTypeDetailSuccess: true,
      };
    }
    case FETCH_VEHICLE_STEREOTYPE_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleStereoTypeDetailSuccess: false,
        isVehicleStereoTypeDetailError: true,
      };
    }

    //DD
    case VEHICLE_MODELDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        vehicleModelDD: temp,
        isVehicleModelDDSuccess: true,
        isVehicleModelDDError: false,
      };
    }
    case VEHICLE_MODELDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleModelDDSuccess: false,
        isVehicleModelDDError: true,
      };
    }
    //END DD

      // Stereo Type DD

    case VEHICLE_STEREOTYPE_DD.SUCCESS: {
      const temp = action.payload;
 
      return {
        ...state,
        isLoading: false,
        vehicleStereoTypeDD: temp,
        isVehicleStereoTypeDDSuccess: true,
        isVehicleStereoTypeDDError: false,
      };
    }
    case VEHICLE_STEREOTYPE_DD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleStereoTypeDDSuccess: false,
        isVehicleStereoTypeDDError: true,
      };
    }
    // END Stereo Type DD

    // UPLOAD_IMAGE Start
    case UPLOAD_IMAGE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isUploadImageSuccess: false,
        isUploadImageError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case UPLOAD_IMAGE.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        imageUploadResponse: data,
        isUploadImageSuccess: true,
        isUploadImageError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // UPLOAD_IMAGE End

    // Export Start
    case EXPORT_VEHICLE_STEREOTYPE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isVehicleStereoTypeExportSuccess: false,
        isVehicleStereoTypeExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_VEHICLE_STEREOTYPE.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "vehicle-stereo-type.xls");
      return {
        ...state,
        isVehicleStereoTypeExportSuccess: true,
        isVehicleStereoTypeExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // Export End

    // EDIT
    case EDIT_VEHICLE_STEREOTYPE.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isVehicleStereoTypeEditSuccess: false,
        isVehicleStereoTypeEditError: true,
      };
    }

    case EDIT_VEHICLE_STEREOTYPE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isVehicleStereoTypeEditSuccess: true,
        isVehicleStereoTypeEditError: false,
      };
    }

    // EDIT END

    // Create
    case INIT_CREATE_VEHICLE_STEREOTYPE_SCREEN: {
      return { ...INITIAL_STATE, savedTableState: state.savedTableState };
    }

    case CREATE_VEHICLE_STEREOTYPE.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isVehicleStereoTypeCreateSuccess: false,
        isVehicleStereoTypeCreateError: true,
      };
    }
    case CREATE_VEHICLE_STEREOTYPE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isVehicleStereoTypeCreateSuccess: true,
        isVehicleStereoTypeCreateError: false,
      };
    }

    //End

    case DELETE_VEHICLE_STEREOTYPE.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isVehicleStereoTypeDeleteSuccess: true,
        isVehicleStereoTypeDeleteError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    case DELETE_VEHICLE_STEREOTYPE.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isVehicleStereoTypeDeleteSuccess: false,
        isVehicleStereoTypeDeleteError: true,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY:
      return {
        ...state,
        shouldOpenDeleteConfirmationPopup: action.payload,
        isVehicleStereoTypeDeleteSuccess: false,
        isVehicleStereoTypeDeleteError: false,
      };

    case VEHICLE_STEREOTYPE_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }

    case TOAST.RESET: {
      return {
        ...state,
        isVehicleStereoTypeCreateSuccess: false,
        isVehicleStereoTypeCreateError: false,
        isVehicleStereoTypeEditError: false,
        isVehicleStereoTypeEditSuccess: false,
        isVehicleStereoTypeDetailError: false,
      };
    }
    default:
      return state;
  }
};
